import { useState } from "react";
import { DotLegalDialog, DotLegalTextField } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "@localization/useTranslation";
import { RiskScenarioRow } from "../RiskAssessmentsOverview.types";
import { RiskAssessmentLifecycleAction, useRetireRiskAssessmentDialog } from "./RetireRiskAssessmentDialog.hooks";

interface RetireRiskAssessmentDialogProps {
    action: RiskAssessmentLifecycleAction;
    scenario: RiskScenarioRow;
    onClose: () => void;
    onSaved: () => void;
}

function RetireRiskAssessmentDialog({ action, scenario, onClose, onSaved }: RetireRiskAssessmentDialogProps) {
    const { translateString } = useTranslation();
    const [reason, setReason] = useState("");
    const { inProgress, submit } = useRetireRiskAssessmentDialog(scenario.id, action, onSaved);

    const isRetire = action === "retire";

    return (
        <DotLegalDialog
            open
            header={translateString(isRetire ? "retireRiskAssessmentTitle" : "reinstateRiskAssessmentTitle")}
            buttonOkText={translateString(isRetire ? "retire" : "reinstate")}
            okButtonDisabled={reason.trim().length === 0}
            inProgress={inProgress}
            onDialogClose={onClose}
            onOkClick={() => submit(reason.trim())}
            size={"sm"}
        >
            <DotLegalTextField label={translateString("reason")} value={reason} onChange={setReason} multiline rows={3} debounce={false} noMargin />
        </DotLegalDialog>
    );
}

export default RetireRiskAssessmentDialog;
